import {getSnoreSettingInfos, getVipFlag, setSnoreSettingInfos} from "../../../utils/api";
import moment from "moment";
import {Dialog} from "vant";
import {eventTracking} from "../../../utils/native";
import {goToOpenVipPage} from "../../../utils/utils";

export default {
    data() {
        return {
            settingDetails: {},
            type: 'local',
            days: 7,
            lastedCheckedDays: 7,
            lastedCheckedType: 'local',

            isCn: true,
            isloading: false,
            noNet: false,
            flag: -1,// -1:未购买过会员 0：会员已过期 1：会员有效
            activeName: 'duration',
            vaildDate: moment()
        }
    },
    watch: {
        '$route.query': {
            handler: function (query) {
                if (query) {
                    this.query = query
                    this.queryIsVip();
                    this.getSnoreSettingInfos()
                }
            },
            immediate: true
        }
    },
    created() {

    },
    activated() {
        this.getSnoreSettingInfos()
    },
    methods: {
        getSnoreSettingInfos() {
            this.isloading = true;
            getSnoreSettingInfos().then((res)=>{
                console.log('res', res)
                this.isloading = false;
                this.type = res.type || 'local';
                this.type = this.type === 'free' ? 'local' : (this.type === 'vip' ? 'cloud' : this.type)
                this.days = res.days || 7;
                this.settingDetails = res;
                // 会员已过期 且过期时间超过存储时间 且存储时间是vip 或者存储方式是云端时，需要手动恢复至非vip的默认值
                let vaildDate = moment(this.vaildDate)
                // console.log('this.flag === 0', this.flag, this.flag === 0, moment().diff(vaildDate, 'days'))
                if(this.flag === 0 && (this.days > 7 || this.type === 'cloud') && moment().diff(vaildDate, 'days') > this.days) {
                    if(this.days > 7) {
                        this.days = 7;
                    }
                    if(this.type==='cloud') {
                        this.type = 'local';
                    }
                    this.setSnoreSettingInfos()
                }

                this.lastedCheckedDays = this.days;
                this.lastedCheckedType = this.type;
            }).catch((err)=>{
                this.isloading = false;
            })
        },
        setSnoreSettingInfos(){
            let value = Object.assign({}, this.settingDetails, {type: this.type, days: this.days} )
            let data = {
                "type":"snore_store",
                "value": JSON.stringify(value)
            }
            console.log('会员过期了，更新setting' +
                'infos')
            setSnoreSettingInfos(data).then((res)=>{

            })
        },


        // 请求是否为会员
        queryIsVip() {
            getVipFlag().then(res => {
                // console.log('getVipFlag', res)
                this.flag = res.vipFlag;// -1:未购买过会员 0：会员已过期 1：会员有效
                this.vaildDate = res.vaildDate;
                // this.flag = 0;
                // this.vaildDate = '2023-10-05 23:59:59';
            }).catch((err)=>{
                if(err.code === "ECONNABORTED") {
                    this.noNet = true;
                }
            })
        },
        getIsNeedVipDialog(checkedValue, name) {
            console.log('e',this.flag == 1, name, checkedValue )
            if(this.flag == 1 ) {
                console.log('已经是会员了')
                return false;
            }
            else if(name === 'duration' && (checkedValue == 30 || checkedValue == 180)) {
                return true;
            }
            else if(name === 'location' && checkedValue == 'cloud') {
                return true;
            }
            else {
                return false
            }
        },
        showVipDialog() {
            const beforeClose = (action) =>
                new Promise((resolve) => {
                    if (action === 'confirm') {
                        goToOpenVipPage()
                        resolve(true);
                    } else {
                        resolve(true);
                    }
                });
            Dialog.confirm({
                title: this.$t('message.snore.tips'),
                message:this.$t('message.snore.vipTips'),
                confirmButtonText: this.$t('message.snore.open'),
                confirmButtonColor: '#4b48dc',
                cancelButtonText: this.$t('message.sleep.compare.cancel'),
                messageAlign: 'left',
                beforeClose,
            });

        },
    }
}
